module.exports = __webpack_public_path__ + "static/img/4.f0d539b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/8/eng/4.png
// module id = k1Nz
// module chunks = 0